module.exports = __webpack_public_path__ + "static/media/open_link.cdb0441b.svg";